import apiService from "../../../../services/service";
import API_ROUTES from "../../../../api-routes";
import Categories from "../../../../assets/categories-subcategories.json";
import Category from "../../../../components/Processes/conversations/utils/categories.json";
import { z } from "zod";

export const fetchRequestUsers = async (
  role,
  entityId = "",
  serviceId = "",
) => {
  // GXM-1800: Use sparse fieldset to optimize response size
  // Request only fields needed for request assignment:
  // - id: for user selection and filtering
  // - first_name, last_name: for display in assignee list
  const fields = "id,first_name,last_name";

  const { data } = await apiService(API_ROUTES.FETCH_USERS, "GET", {
    replace: {
      page: 1,
      pageSize: 100,
      role,
      searchValue: "",
      entity: entityId,
      service: serviceId,
      fields,
    },
    schema: z.object({
      page: z.number().optional(),
      pageSize: z.number().optional(),
      role: z.string().optional(),
      search: z.string().optional(),
      entity: z.string().optional(),
      service: z.string().optional(),
    }),
  });
  const users = data?.users || [];
  return { users };
};

export const fetchEntities = async ({
  pageIndex = 0,
  pageSize = 100,
  searchValue = "",
} = {}) => {
  const { data } = await apiService(API_ROUTES.ALL_ENTITIES, "GET", {
    replace: {
      page: pageIndex + 1,
      pageSize,
      searchValue,
    },
    schema: z.object({
      page: z.number().optional(),
      pageSize: z.number().optional(),
      search: z.string().optional(),
    }),
  });
  return { data };
};

export const saveRequest = async (requestData, requestType) => {
  const { data, status } = await apiService(API_ROUTES.ADD_REQUEST, "POST", {
    body: requestData,
    replace: {
      requestType: requestType,
    },
    schema: z.object({
      requestType: z.string(),
    }),
  });
  return { data, status };
};

export const mergeCategories = (selectedKeys, role = "GXM_ADMIN") => {
  const mergedByCode = new Map();
  for (const key of selectedKeys) {
    const groups = Categories[key];
    if (!Array.isArray(groups)) continue;

    for (const cat of groups) {
      if (!cat || !cat.code) continue;

      if (!mergedByCode.has(cat.code)) {
        mergedByCode.set(cat.code, {
          name: cat.name,
          code: cat.code,
          subCategory: new Map(),
        });
      }

      const bucket = mergedByCode.get(cat.code);

      if (!bucket.name && cat.name) bucket.name = cat.name;

      if (Array.isArray(cat.subCategory)) {
        for (const sub of cat.subCategory) {
          if (!sub || !sub.code) continue;
          if (!bucket.subCategory.has(sub.code)) {
            bucket.subCategory.set(sub.code, {
              name: sub.name,
              code: sub.code,
            });
          }
        }
      }
    }
  }

  const merged = Array.from(mergedByCode.values()).map((cat) => ({
    name: cat.name,
    code: cat.code,
    subCategory: Array.from(cat.subCategory.values()),
  }));

  return merged || [];
};
